(ns frontend.view.modals.change-password.view
  (:require
   [clojure.string :as string]
   [common.localization :as loc]
   [common.security.password :as password]
   [frontend.view.modals.change-password.events :as events]
   [ui.color :as c]
   [ui.components.button.view :as button]
   [ui.components.modal.view :as modal]
   [ui.editors.labelled-input.view :as labelled-input]))

(defonce modal-key :change-password-modal)

(defn password-change-view
  [state pw-1-error pw-2-error]
  [:div
   [:div
    [:form
     {:class "flex flex-col gap-4"}

     [:div
      {:class "flex flex-col gap-1"}
      [labelled-input/view
       {:label     (loc/tr :current-password)
        :dom-id "change-password-modal-old-password"
        :data-type :data.type/password
        :value     (get @state :old-password)
        :on-change (fn [new-value]
                     (swap! state assoc :old-password new-value))}]
      [:div
       {:class "flex gap-3"}
       (when (:error-message @state)
         [:div
          {:class "text-xs text-danger-light-text"}
          (:error-message @state)])]]

     [:div
      {:class "flex flex-col gap-1"}
      [labelled-input/view
       {:label     (loc/tr :new-password)
        :data-type :data.type/password
        :dom-id "change-password-modal-new-password"
        :value     (get @state :new-pass-1)
        :on-change (fn [new-value]
                     (swap! state assoc :new-pass-1 new-value))}]
      (when pw-1-error
        [:div
         {:class "text-xs text-danger-light-text"}
         pw-1-error])]

     [:div
      {:class "flex flex-col gap-1"}
      [labelled-input/view
       {:label     (loc/tr :repeat-new-password)
        :data-type :data.type/password
        :dom-id "change-password-modal-new-password-2"
        :value     (get @state :new-pass-2)
        :on-change (fn [new-value]
                     (swap! state assoc :new-pass-2 new-value))}]
      (when pw-2-error
        [:div
         {:class "text-xs text-danger-light-text"}
         pw-2-error])]]]])

(defn success-view
  [close-modal!]
  [:div
   [:h2.text-center.mt-3 (loc/tr :password-changed)]
   [:div
    [button/primary-solid
     {:class-name "ms-1"
      :dom-id "change-password-modal-success-ok"
      :on-click   #(close-modal!)}
     (loc/tr :ok)]]])

(defn view
  [{:keys [_shown? _close-modal! _props state _topmost?]}]
  (events/reset-state! state)
  (fn [{:keys [shown? close-modal! state topmost?]}]
    (let [pw-rule :length-8-rule                                                                    ; TODO: change to (:tenant/password-validation-rule @session/tenant)
          {:keys [old-password new-pass-1 new-pass-2]} @state
          pw-1-error (when new-pass-1
                       (if (= new-pass-1 old-password)
                         (loc/tr :password-violation/same-as-old)
                         (password/validate-error pw-rule new-pass-1)))
          pw-2-error (when (and new-pass-1 new-pass-2)
                       (password/validate-error pw-rule new-pass-1 new-pass-2))
          form-ok? (and (not (string/blank? old-password))
                        new-pass-1
                        new-pass-2
                        (not pw-1-error)
                        (not pw-2-error))]
      [modal/view
       {:visible?      (and shown? topmost?)
        :hide!         close-modal!
        :backdrop      "static"
        :color         ::c/danger
        :close-button? true}
       (loc/tr :change-password)
       [:<>
        (if (:password-changed @state)
          [success-view close-modal!]
          [password-change-view state pw-1-error pw-2-error])]
       (when-not (:password-changed @state)
         [:<>
          [:div
           {:class "flex gap-3 items-center"}
           [button/secondary-hollow
            {:on-click #(close-modal!)}
            (loc/tr :cancel)]]

          [:div
           {:class "flex gap-3 justify-end items-center"}
           [button/primary-solid
            {:disabled? (not form-ok?)
             :on-click  (partial events/save-password! state)}
            (loc/tr :save)]]])])))
